import React from "react";
import { FaBriefcase, FaChartLine, FaWallet } from "react-icons/fa";

const IndustryTrends = () => {
  const data = [
    {
      icon: <FaBriefcase size={30} className="text-blue-600" />,
      value: "$667.9 bn",
      description: "Estimated Generative AI Market Size By 2030 Growing At A CAGR Of 47.5%",
      source: "Fortune Business",
    },
    {
      icon: <FaChartLine size={30} className="text-blue-600" />,
      value: "27.6%",
      description: "Expected CAGR Of The Global Data Analytics Market From 2023 To 2030",
      source: "Market Research",
    },
    {
      icon: <FaWallet size={30} className="text-blue-600" />,
      value: "₹9,57,470",
      description: "Average Annual Salary Of A Data Analytics Professional In India",
      source: "Glassdoor",
    },
  ];

  return (
    // <section className="bg-gray-50 py-10 px-4 md:px-10">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Industry Trends</h2>
        <p className="text-gray-600 mt-2 text-sm md:text-base md:w-[60%] w-full">
          The global big data and data analytics market was valued at $225.3 billion in 2023 
          and is projected to reach $665.7 billion by 2033, growing at a CAGR of 11.6% from 2024 to 2033.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          {data.map((item, index) => (
            <div key={index} className="bg-white shadow-md rounded-lg p-6 flex flex-col items-center text-center">
              <div className="bg-blue-100 p-3 rounded-full">{item.icon}</div>
              <h3 className="text-xl font-semibold mt-3">{item.value}</h3>
              <p className="text-gray-600 text-sm mt-2">{item.description}</p>
              <span className="text-gray-400 text-xs mt-3">Source: {item.source}</span>
            </div>
          ))}
        </div>
      </div>
    // </section>
  );
};

export default IndustryTrends;
